<template>
	<jeet11 :isRummyOptionSelected="true" />
</template>

<script>
import Jeet11 from "../Jeet11";
export default {
	components: {
		jeet11: Jeet11
	}
};
</script>
